import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "filter-newsroom-event__title" };
const _hoisted_2 = ["aria-expanded"];
const _hoisted_3 = { class: "filter-newsroom-event__zone-title-text" };
const _hoisted_4 = ["data-role"];
const _hoisted_5 = { class: "filter-newsroom-event__zonecontent-scroll" };
const _hoisted_6 = { class: "filter-newsroom-event__formfields" };
const _hoisted_7 = { class: "form__fieldset is-small" };
const _hoisted_8 = { class: "form__row filter-newsroom-event__checkboxarea" };
const _hoisted_9 = { class: "form__col" };
const _hoisted_10 = { class: "form__checkbox" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "form__label-wrapper" }, [
    /*#__PURE__*/ _createElementVNode("strong", { class: "form__checkbox-legend" })
], -1 /* HOISTED */);
const _hoisted_12 = { class: "form__checkbox-wrapper" };
const _hoisted_13 = { class: "filter-newsroom-event__buttonarea" };
import { computed, ref } from 'vue';
import { useI18n, useNewsFilter, useClickOutside, useTopicsDropdown } from '../features';
import FilterCheckbox from './TopicFilterCheckboxItem.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TopicFilter',
    props: {
        enable: { type: Boolean }
    },
    setup(__props) {
        const { enable } = __props;
        const isOpen = ref(false);
        const { applyFilters, selectedTopics } = useNewsFilter();
        const toggleDropdown = () => {
            isOpen.value = !isOpen.value;
        };
        const { elementRef } = useClickOutside(isOpen, toggleDropdown);
        const submitSelection = () => {
            isOpen.value = false;
            if (checkboxItems.value) {
                selectedTopics.value = checkboxItems.value.filter(item => item.checked && item.id !== "all").map((item) => ({
                    id: item.id,
                    tName: item.title,
                }));
                applyFilters();
            }
        };
        const { t } = useI18n();
        const { checkboxItems, updateCheckbox } = useTopicsDropdown();
        const dropdownTopics = computed(() => checkboxItems);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "elementRef",
                ref: elementRef,
                class: _normalizeClass(["filter-newsroom-event__filter", _ctx.enable ? '' : 'is-hidden'])
            }, [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('filter_topic_title')), 1 /* TEXT */),
                _createElementVNode("div", {
                    class: _normalizeClass(["filter-newsroom-event__zone", isOpen.value ? 'is-showFilter' : 'is-hideFilter'])
                }, [
                    _createElementVNode("button", {
                        onClick: toggleDropdown,
                        class: "filter-newsroom-event__zone-title",
                        "aria-haspopup": "true",
                        "aria-expanded": isOpen.value,
                        type: "button"
                    }, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('filter_topic_choose')), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_2),
                    (isOpen.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "filter-newsroom-event__zonecontent",
                            "data-role": _unref(t)('filter_topic_dropdown_placeholder')
                        }, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("fieldset", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _createElementVNode("div", _hoisted_10, [
                                                    _hoisted_11,
                                                    _createElementVNode("div", _hoisted_12, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dropdownTopics.value.value, (item, index) => {
                                                            return (_openBlock(), _createBlock(FilterCheckbox, {
                                                                key: index,
                                                                item: item,
                                                                "onUpdate:checked": ($event) => (_unref(updateCheckbox)(index, $event))
                                                            }, null, 8 /* PROPS */, ["item", "onUpdate:checked"]));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: submitSelection,
                                    class: "filter-newsroom-event__submitbutton"
                                }, _toDisplayString(_unref(t)('filter_time_button')), 1 /* TEXT */)
                            ])
                        ], 8 /* PROPS */, _hoisted_4))
                        : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */)
            ], 2 /* CLASS */));
        };
    }
});
